(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      // KAOS: on phones, keep the compact header and logo visible while scrolling.
      // Desktop retains the current scroll-up reveal behavior.
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size' ||
        window.matchMedia('(max-width: 749px)').matches;
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kaos-home-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('kaos-hero-slideshow-2026-4')) {
    customElements.define('kaos-hero-slideshow-2026-4', class extends HTMLElement {
      connectedCallback() {
        this.slides = [this.querySelector(':scope > .kaos-fw-banner__image'), ...this.querySelectorAll('.kaos-fw-banner__slide')];
        this.index = 0;
        this.paused = matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.visible = true;
        this.control = this.querySelector('.kaos-fw-banner__pause');
        this.control.hidden = false;
        this.updateControl();
        this.control.onclick = () => { this.paused = !this.paused; this.updateControl(); this.schedule(); };
        this.visibility = () => this.schedule();
        document.addEventListener('visibilitychange', this.visibility);
        this.observer = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; this.schedule(); });
        this.observer.observe(this);
        this.schedule();
      }
      updateControl() {
        this.control.textContent = this.paused ? '▷' : 'Ⅱ';
        this.control.setAttribute('aria-pressed', String(this.paused));
        this.control.setAttribute('aria-label', this.paused ? 'Avvia le immagini' : 'Metti in pausa le immagini');
      }
      schedule() {
        clearTimeout(this.timer);
        if (this.paused || !this.visible || document.hidden || this.slides.length < 2) return;
        this.timer = setTimeout(() => {
          if (!this.isConnected || this.paused || !this.visible || document.hidden) return;
          const next = (this.index + 1) % this.slides.length;
          this.slides.forEach((slide, i) => {
            if (i > 0) {
              slide.classList.toggle('is-active', i === next);
              slide.setAttribute('aria-hidden', String(i !== next));
            }
          });
          this.index = next;
          this.schedule();
        }, 2000);
      }
      disconnectedCallback() {
        clearTimeout(this.timer);
        this.observer?.disconnect();
        document.removeEventListener('visibilitychange', this.visibility);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
  if (!customElements.get('kaos-look-recommendations')) {
    customElements.define(
      'kaos-look-recommendations',
      class extends HTMLElement {
        connectedCallback() {
          if (this.dataset.kaosInitialized === 'true') return;
          this.dataset.kaosInitialized = 'true';

          if (!('IntersectionObserver' in window)) {
            this.loadRecommendations();
            return;
          }

          this.observer = new IntersectionObserver(
            (entries) => {
              if (!entries[0].isIntersecting) return;
              this.observer.disconnect();
              this.loadRecommendations();
            },
            { rootMargin: '0px 0px 400px 0px' }
          );
          this.observer.observe(this);
        }

        disconnectedCallback() {
          if (this.observer) this.observer.disconnect();
        }

        async requestRecommendations(intent) {
          const url = new URL(this.dataset.url, window.location.origin);
          url.searchParams.set('product_id', this.dataset.productId);
          url.searchParams.set('section_id', this.dataset.sectionId);
          url.searchParams.set('limit', this.dataset.limit);
          url.searchParams.set('intent', intent);

          const response = await fetch(url.toString(), { credentials: 'same-origin' });
          if (!response.ok) throw new Error('KAOS product recommendations unavailable');

          const documentHtml = new DOMParser().parseFromString(await response.text(), 'text/html');
          const result = documentHtml.querySelector('kaos-look-recommendations [data-kaos-look-results]');
          if (!result || !result.querySelector('.kaos-look__item')) return false;

          const target = this.querySelector('[data-kaos-look-results]');
          if (!target) return false;
          target.innerHTML = result.innerHTML;
          return true;
        }

        async loadRecommendations() {
          let displayed = false;

          try {
            displayed = await this.requestRecommendations('complementary');
          } catch (error) {
            console.warn('KAOS complementary recommendations unavailable', error);
          }

          if (!displayed) {
            try {
              displayed = await this.requestRecommendations('related');
            } catch (error) {
              console.warn('KAOS related recommendations unavailable', error);
            }
          }

          if (!displayed) this.hidden = true;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-autoplay"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('kaos-autoplay-video')) {
    customElements.define('kaos-autoplay-video', class extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('video');
        if (!this.video) return;
        this.visible = false;
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.syncPlayback = () => {
          if (!this.visible || document.hidden) {
            this.video.pause();
            return;
          }
          if (this.motion.matches) {
            this.video.controls = true;
            this.video.pause();
            return;
          }
          const playback = this.video.play();
          if (playback) {
            playback.then(() => {
              if (!this.isConnected || !this.visible || document.hidden || this.motion.matches) {
                this.video.pause();
              } else {
                this.video.controls = false;
              }
            }).catch(() => {
              this.video.controls = true;
            });
          }
        };
        if (!('IntersectionObserver' in window)) return;
        this.observer = new IntersectionObserver((entries) => {
          this.visible = entries[0].isIntersecting;
          this.syncPlayback();
        }, { threshold: 0 });
        this.observer.observe(this);
        document.addEventListener('visibilitychange', this.syncPlayback);
        this.motion.addEventListener('change', this.syncPlayback);
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        document.removeEventListener('visibilitychange', this.syncPlayback);
        this.motion?.removeEventListener('change', this.syncPlayback);
        this.video?.pause();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
